import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { HotkeyService } from '../../../UI-Lib/HotKeys/hotKeys.service';
import { UpgradeNavigationServiceHandler } from '../../../Common/Routing/upgrade-navigation-handler.service';
import { CompanyService } from '../../../Entity/Company/company.service';
import { WeissmanDateFormatPipe } from '../../../UI-Lib/Pipes';
import { DecimalPipe, PercentPipe } from '@angular/common';
import { WeissmanKeyValueDisplayPipe } from '../../../UI-Lib/Pipes';
import { BusyIndicatorRef, BusyIndicatorService } from '../../../Busy-Indicator';
import { WeissmanModalService } from '../../../Compliance/WeissmanModalService';
import { RestrictService, Roles } from '../../../Common/Permissions/restrict.service';
import {
    MessageBoxButtons,
    MessageBoxOptions,
    MessageBoxResult,
    MessageBoxService
} from '../../../UI-Lib/Message-Box/messagebox.service.upgrade';
import { SiteRepository } from '../../../Core-Repositories';
import { ParcelService } from '../../../Entity/Parcel/parcel.service.upgrade';
import {
    CellClassParams,
    GridApi,
    GridOptions,
    GridReadyEvent,
    ICellEditorParams,
    ValueFormatterParams
} from 'ag-grid-community';
import { RentRollAgGridDataSource, RentRollDataSourceParams } from './agGridDataSource';
import { BehaviorSubject, lastValueFrom, Subject, Subscription } from 'rxjs';
import { BreadCrumb } from '../../../UI-Lib/Bread-Crumb/breadCrumbs.component';
import {
    AgGridOptionsBuilder
} from '../../../Compliance/AgGrid';
import {
    AgGridMultiSelectTracker
} from '../../../Compliance/AgGrid/MultiSelectTracker';
import { AgGridExportOptions, AgGridExportStartLRP } from '../../../Compliance/AgGrid/ToolPanel/models';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { RentRollRepository } from '../rentRoll.repository';
import {
    ICellRendererParamsForRentRollGridAction} from './agGridActionCellRendererComponent';
import { MessageModalService } from '../../../UI-Lib/Message-Box/messageModal.service';
import {
    DeleteConfirmationComponent,
    DeleteConfirmationComponentParams
} from '../../../Common/Delete-Confirmation/deleteConfirmation.component';
import LongRunningProcessTypeEnum = Compliance.LongRunningProcessTypeEnum;
import {
    RentRollBulkUpdateComponent,
    RentRollBulkUpdateParams
} from '../Rent-Roll-Bulk-Update/rentRollBulkUpdate.component';
import { RENT_ROLL_LIST_COLUMNS } from './rentRollList.columns';

@Component({
    selector: 'rent-roll-list',
    templateUrl: './rentRollList.component.html',
    styleUrls: ['./rentRollList.component.scss'],
    providers: [HotkeyService],
    standalone: false
})
export class RentRollListComponent implements OnInit, OnDestroy {
    constructor(
        public readonly percentPipe: PercentPipe,
        public readonly datePipe: WeissmanDateFormatPipe,
        public readonly decimalPipe: DecimalPipe,
        private readonly _routerService: UpgradeNavigationServiceHandler,
        private readonly _rentRollRepository: RentRollRepository,
        private readonly _companyService: CompanyService,
        private readonly _keyValueDisplayPipe: WeissmanKeyValueDisplayPipe,
        private readonly _busyIndicatorService: BusyIndicatorService,
        private readonly _modalService: WeissmanModalService,
        private readonly _restrictService: RestrictService,
        private readonly _messageBoxService: MessageBoxService,
        private readonly _siteService: SiteRepository,
        private readonly _parcelService: ParcelService,
        private readonly _messageModalService: MessageModalService
    ) {
    }

    @Input() companyIdFilter: number;
    @Input() siteIdFilter: number;
    @Input() parcelIdFilter: number;
    @Input() isEmbededMode: boolean = false;
    @Input() onLoading: boolean;
    @Output() onLoadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    breadcrumbs: BreadCrumb[] = [];
    rentRollGridTotalsRow: any;
    rentRollGridSelectedTotalsRow: any;
    selectedTotalsLoading: boolean = true;
    companyId: number;
    newCompanyId: number;
    companyName: string;
    canEdit: boolean = false;
    canViewRyanPrivateItems: boolean = false;
    isInitialized: boolean = false;
    gridId: System.Guid = '8BD07243-8F4D-403E-BC70-54401905DF14';
    isBulkUpdateVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    isBulkDeleteVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    totalsLoading: any;
    busyRefId: string = this._busyIndicatorService.generateUniqueMessageIdentifier();
    filterHref: string;
    siteName: string;
    parcelName: string;
    siteId: number;
    selectedEndDate: Date;
    endDates: Date[];

    gridOptions: GridOptions = this._getGridOptions()
    gridTracker: AgGridMultiSelectTracker;
    exportOptions: AgGridExportOptions = this._getExportOptions();
    gridApi: GridApi;

    private _gridDataSource: RentRollAgGridDataSource;
    private _gridMultiSelectSub: Subscription;
    private _busyRef: BusyIndicatorRef;
    private _destroy$: Subject<void> = new Subject();

    get refreshing(): boolean {
        return this._gridDataSource && this._gridDataSource.isRefreshing;
    }

    async ngOnInit(): Promise<void> {
        // this._helpService.setContent(ASSET_LIST_HELP);
        // this._hotkeyService.add({ keys: 'alt.r' }).subscribe(() => this.gridTracker.getSelectedRowsCount() && this.bulkUpdate('r'));

        this.companyId = this.companyIdFilter ?? parseInt(this._routerService.getQuerystringParam('companyId'));

        if (!this.isEmbededMode && typeof this.siteIdFilter === 'undefined') {
            this.siteIdFilter = parseInt(this._routerService.getQuerystringParam('siteId'));
        }

        if (!this.isEmbededMode && typeof this.parcelIdFilter === 'undefined') {
            this.parcelIdFilter = parseInt(this._routerService.getQuerystringParam('parcelId'));
        }

        this.newCompanyId = this.companyId;

        let busyRef: BusyIndicatorRef;

        if (this.isEmbededMode) {
            this.onLoading = true;
            this.onLoadingChange.emit(true);

            if (typeof this.siteIdFilter !== 'undefined') {
                this.filterHref = this._routerService.getHrefFromState('siteRentRoll', {
                    companyId: this.companyId,
                    siteId: this.siteIdFilter
                });
            } else if (typeof this.parcelIdFilter !== 'undefined') {
                this.filterHref = this._routerService.getHrefFromState('rentRollParcelFilter', {
                    companyId: this.companyId,
                    parcelId: this.parcelIdFilter
                });
            }
        } else {
            busyRef = this._busyIndicatorService.show({ message: 'Loading' });
        }

        await this._initFromServer(busyRef)

        return Promise.resolve();
    }

    ngOnDestroy(): void {
        this._gridMultiSelectSub && this._gridMultiSelectSub.unsubscribe();
        this._destroy$.next();
        this._destroy$.complete();
    }

    async onAgGridReady(event: GridReadyEvent): Promise<void> {
        this.gridApi = event.api;
        this.gridApi.setGridOption("loading", true);

        this.gridTracker = new AgGridMultiSelectTracker(this.gridOptions, this.gridApi, this._getGridRowIds.bind(this));

        this._setGridColumns();

        // notify the bulk update button (on the column tool panel) every time the grid selection changes
        this._gridMultiSelectSub = this.gridTracker.selectedRows$.subscribe(async () => {
            const isBulkUpdateVisible = this.canEdit && this.gridTracker.hasSelectedRows();
            this.isBulkUpdateVisible$.next(isBulkUpdateVisible);
            this.isBulkDeleteVisible$.next(isBulkUpdateVisible);
            await this._reloadTotals();
        });

        // if(!this.isEmbededMode && this.parcelIdFilter) {
        //     const parcelFilterModel = {
        //         [Core.RentRollLineItemPropertyEnum.ParcelName]: {
        //             "filterType": "text",
        //             "filterConditionType": 0,
        //             "filterValues": [
        //                 {
        //                     "filterValue": this.parcelName,
        //                     "filterType": {
        //                         "displayKey": "equals",
        //                         "displayName": "Equals",
        //                         "numberOfInputs": 1
        //                     }
        //                 }
        //             ]
        //         }
        //     };

        //     this.gridOptions.floatingFilter = true;
        //     this.gridApi.setFilterModel(parcelFilterModel);
        // }
        this._setDataSource();
    }

    onEndDateChange(): void {
        this._refreshDataSource();
    }

    async refresh(): Promise<void> {
        await this._refreshDataSource();
    }

    async bulkDelete(): Promise<void> {
        const confirmOptions = {
            message: 'Are you sure you want to delete selected line items?',
            buttons: MessageBoxButtons.OKCancel
        } as MessageBoxOptions;

        const result = await this._messageBoxService.open(confirmOptions);

        if(result !== MessageBoxResult.OK) return;

        const params: DeleteConfirmationComponentParams = {
            item: 'Rent Roll Line Items',
            message: 'Are you sure you want to delete selected line items? If you choose to proceed, all information related to line items will be removed and cannot be recovered.'
        };

        const shouldDelete = await this._modalService.showAsync(DeleteConfirmationComponent, params, 'modal-md');

        if (shouldDelete) {
            this._showBusyIndicator('Bulk Delete', 'Deleting line items', null, false, false);

            const model: Compliance.RentRollLineItemBulkDeleteModel = {
                lastModifiedTimestamp: this._gridDataSource.lastModifiedTimestamp,
                selectAllRows: this.gridTracker.getSelectedRowsModel().selectAllRows,
                selectedRows: this.gridTracker.getSelectedRowsModel().selectedRows,
                siteId: this.siteIdFilter,
                endDate: this.selectedEndDate
            };

            try {
                const longRunningProcessId = await lastValueFrom(this._rentRollRepository.startBulkDelete(this.companyId, model));
                await this._busyRef.setLongRunningProcessId(longRunningProcessId);
            } catch (e) {
                await this._hideBusyIndicator();
                return Promise.reject(e);
            }
        }

        return Promise.resolve();
    }

    handleTotalsUpdate = (totals: Core.RentRollLineItemSearchTotalModel, selectedTotals: boolean = false, isLoading: boolean = false) => {
        const model = {
            //cost: totals.totalCost,
            //sourceCost: totals.totalSourceCost,
        };
        const rentRollRow: any = {
            model: model,
            getModel: () => {
                return model;
            },
            displayPipe: this._keyValueDisplayPipe,
            index: 0,
            sqFt: totals && totals.sqFt,
            annualMarketRent: totals && totals.annualMarketRent,
            annualMarketRentCalculated: totals && totals.annualMarketRent,
            monthlyMarketRent: totals && totals.monthlyMarketRent,
            monthlyMarketRentCalculated: totals && totals.monthlyMarketRent,
            annualRent: totals && totals.annualRent,
            annualRentCalculated: totals && totals.annualRent,
            monthlyRent: totals && totals.monthlyRent,
            monthlyRentCalculated: totals && totals.monthlyRent,
            annualOther: totals && totals.annualOther,
            annualOtherCalculated: totals && totals.annualOther,
            monthlyOther: totals && totals.monthlyOther,
            monthlyOtherCalculated: totals && totals.monthlyOther,
            annualCAM: totals && totals.annualCAM,
            annualCAMCalculated: totals && totals.annualCAM,
            monthlyCAM: totals && totals.monthlyCAM,
            monthlyCAMCalculated: totals && totals.monthlyCAM,
            occupancySqFt: totals && totals.occupancySqFt,
            vacancySqFt: totals && totals.vacancySqFt,
            totalSqFt: totals && totals.totalSqFt,
            occupiedUnits: totals && totals.occupiedUnits,
            vacantUnits: totals && totals.vacantUnits,
            totalUnits: totals && totals.totalUnits,
            // balance: totals && totals.totalBalance,
            unit: 'TOTAL',
            totalsRow: true
        };

        if (isLoading) {
            this.totalsLoading = this._gridDataSource.getLoadingMessage(msg => {
                rentRollRow.unit = msg;
                this.gridApi.setGridOption('pinnedBottomRowData', [rentRollRow]);
            });
            return;
        } else if (!isLoading && this.totalsLoading >= 0) {
            clearInterval(this.totalsLoading);
            this.totalsLoading = null;
        }

        if (selectedTotals) {
            rentRollRow.selectedTotalsRow = true;
            rentRollRow.unit = 'SELECTED';
            this.rentRollGridSelectedTotalsRow = rentRollRow;
        } else {
            rentRollRow.totalsRow = true;
            this.rentRollGridTotalsRow = rentRollRow;
        }
        const totalRows = [this.rentRollGridTotalsRow];
        if (this.gridTracker.hasAnythingSelected()) {
            totalRows.push(this.rentRollGridSelectedTotalsRow);
        }
        setTimeout(() => this.gridApi.setGridOption('pinnedBottomRowData', totalRows), 100);
    };

    async bulkUpdate(): Promise<void> {
        const params: RentRollBulkUpdateParams = {
            companyId: this.companyId,
            siteId: this.siteIdFilter,
            selection: this.gridTracker.getSelectedRowsModel(),
            selectedCount: this.gridTracker.getSelectedRowsCount(),
            endDate: this.selectedEndDate
        };

        const result = await this._modalService.showAsync(RentRollBulkUpdateComponent, params, 'modal-md');

        if (!result) {
            return Promise.resolve();
        }

        this.gridTracker.clear();
        await this.refresh();
    }

    async updateIsValidated(params: ICellEditorParams, updatedValue: boolean): Promise<void> {
        const data = params.data as Core.RentRollLineItemModel;

        if (!data) {
            return Promise.resolve();
        }

        const initialValue = params.value;
        if (updatedValue === initialValue) {
            return Promise.resolve();
        }

        const updateModel: Core.RentRollLineItemIsValidatedUpdateModel = {
            rentRollLineItemId: data.rentRollLineItemId,
            isValidated: updatedValue,
            rowVersion: data.rowVersion
        };

        const busyRef = this._busyIndicatorService.show({ message: 'Saving' });

        try {
            const result = await lastValueFrom(this._rentRollRepository.updateIsValidated(updateModel));
            data.isValidated = result.isValidated;
            data.validatedBy = result.validatedBy;
            data.validatedDate = result.validatedDate;
            data.rowVersion = result.rowVersion;
        } catch (e) {
            data.isValidated = initialValue;
            throw e;
        } finally {
            await busyRef.hide();
        }

        params.node.setData(data);

        return Promise.resolve();
    }

    getCellClass(params: CellClassParams): string {
        const rentRollItem = params.data as Core.RentRollLineItemModel;
        if (!rentRollItem) {
            return '';
        }

        const actualValue = rentRollItem[params.colDef.field];
        const calcValue = rentRollItem[`${params.colDef.field}Calculated`];

        return calcValue !== actualValue ? 'ag-numeric-cell ws-calculated' : 'ag-numeric-cell';
    }

    getCalcOrUncalcValue(params: ValueFormatterParams): string {
        const rentRollItem = params.data as Core.RentRollLineItemModel;
        if (!rentRollItem) {
            return '';
        }

        const actualValue = rentRollItem[params.colDef.field];
        const calcValue = rentRollItem[`${params.colDef.field}Calculated`];
        const displayValue = actualValue || calcValue || 0;

        return this.decimalPipe.transform(displayValue, '1.2-2');
    }

    async deleteItem(params: ICellRendererParamsForRentRollGridAction) {
        const item = params.data as Core.RentRollLineItemModel;

        if (!item) {
            return;
        }

        try {
            await this._messageModalService.confirm(
                `Are you sure you wish to delete Unit ${item.unit}?`,
                'Confirm'
            );
        } catch (e) {
            return Promise.resolve(false);
        }

        const busyRef = this._busyIndicatorService.show({ message: 'Deleting' });
        try {
            await lastValueFrom(this._rentRollRepository.deleteItem(item.rentRollLineItemId));
            this._refreshDataSource();
            return Promise.resolve(true);
        } finally {
            busyRef.hide();
        }

    }

    private async _getGridRowIds(skip: number, take: number): Promise<Compliance.QueryResultModel<number>> {
        return this._gridDataSource.getRowIdsInternal(skip, take);
    }

    private async _refreshDataSource(): Promise<void> {
        if (!this._gridDataSource) {
            const success = this._setDataSource();
            if (!success) {
                return;
            }
        }

        this.gridTracker.clear(false);

        this.isBulkUpdateVisible$.next(false);
        this.isBulkDeleteVisible$.next(false);

        this._gridDataSource.clearTotals();

        this._gridDataSource.refresh();
    }

    private _setDataSource(): boolean {
        if (!this.gridApi || this._gridDataSource) {
            return false;
        }

        this.gridTracker.clear(false);

        this.isBulkUpdateVisible$.next(false);
        this.isBulkDeleteVisible$.next(false);

        const dataSourceParams = (): RentRollDataSourceParams => {
            return {
                companyId: this.companyId,
                siteId: this.siteIdFilter,
                endDate: this.selectedEndDate
            };
        };

        this._gridDataSource = new RentRollAgGridDataSource(
            this.gridApi,
            this._rentRollRepository,
            dataSourceParams,
            this.handleTotalsUpdate
        );

        this.gridApi.updateGridOptions({ datasource: this._gridDataSource });
        return true;
    }

    private _setGridColumns(): void {
        this.gridApi.setGridOption('columnDefs', []);
        const columns = RENT_ROLL_LIST_COLUMNS(this);
        this.gridApi.setGridOption('columnDefs', columns);
        this.gridApi.setFilterModel(null);
    }

    private async _reloadTotals(): Promise<void> {
        if (!this._gridDataSource) {
            return;
        }

        this.selectedTotalsLoading = true;

        try {
            const result = await this._gridDataSource.getSelectedRowTotals(this.gridTracker.getSelectedRowsModel());
            this.selectedTotalsLoading = false;
            this.handleTotalsUpdate(result, true);
        } finally {
            this.selectedTotalsLoading = false;
        }
    }

    private _showBusyIndicator(title: string, message: string = 'Working on it...', lrpId: number, canDismiss = true, hasProgressBar = true): void {
        if (this._busyRef) {
            this._busyRef.updateMessage(message, this.busyRefId);
            this._busyRef.setLongRunningProcessId(lrpId);
            return;
        }

        this._busyRef = this._busyIndicatorService.show({
            identifier: this.busyRefId,
            longRunningProcessId: lrpId,
            title: title ? title : 'Processing',
            message: message,
            hasProgressBar: hasProgressBar,
            canDismiss
        });

        this._busyRef.onProgressBarComplete().pipe(takeUntil(this._destroy$)).subscribe(async (success) => {
            await this._hideBusyIndicator();
            if (success) {
                await this._initEndDates();
                this.refresh();
            }
        });
    }

    private async _hideBusyIndicator(): Promise<void> {
        if (this._busyRef) {
            await this._busyRef.hide();
            this._busyRef = null;
        }
        this._destroy$.next();
    }

    private async _initEndDates() {
        this.endDates = await lastValueFrom(this._rentRollRepository.getRentRollEndDates(this.companyId, this.siteIdFilter));

        if (!_.includes(this.endDates, this.selectedEndDate)) {
            this.selectedEndDate = _.maxBy(this.endDates, x => new Date(x));
        }
    }

    private _getGridOptions(): GridOptions {
        return new AgGridOptionsBuilder({
            onFilterChanged: () => this.gridTracker.onGridFilterChanged(),
            onSortChanged: () => this.gridTracker.onGridSortChanged(),
            rowClassRules: {
                'ag-row-selected': (params) => params.data && this.gridTracker.isRowSelected((params.data as Core.RentRollLineItemModel).rentRollLineItemId),
                'totals-row': (params) => params.data && params.data.totalsRow,
                'selected-totals-row': (params) => params.data && params.data.selectedTotalsRow
            }
        })
        .withColumnPinning()
        .buildDefault(this);
    }

    private _getExportOptions(): AgGridExportOptions {
        return {
            start: async (columnsToReturn: Compliance.NameValuePair<string>[], fileFormat: Compliance.ExportFileFormatEnum): Promise<AgGridExportStartLRP> => {
                const searchParams = this._gridDataSource.getSearchParamsWithoutPagination();

                searchParams.selectedRows = this.gridTracker.getSelectedRowsModel();
                if (!searchParams.selectedRows.selectAllRows && searchParams.selectedRows.selectedRows.length === 0) {
                    searchParams.selectedRows.selectAllRows = true;
                }
                const exportModel: Compliance.RentRollLineItemExportModel = {
                    searchModel: searchParams,
                    columnsToReturn: columnsToReturn,
                    selectedRows: searchParams.selectedRows
                };

                const lrp$ = this._rentRollRepository.startRentRollExport(this.companyId, exportModel);
                const longRunningProcessId = await lastValueFrom(lrp$);
                return { longRunningProcessId, longRunningProcessTypeId: LongRunningProcessTypeEnum.RentRollLineItem };
            },
            canCancel: true
        };
    }

    private async _initFromServer(busyRef: BusyIndicatorRef): Promise<void> {
         try {
            this.canEdit = await this._restrictService.hasCompanyPermission(this.companyId, Core.AccessRightsEnum.Write);
            this.canViewRyanPrivateItems = this._restrictService.isInRole(Roles.RYANPRIVATEITEMSVIEW);

            let sitePromise: Promise<void>;

            if (!this.isEmbededMode && this.siteIdFilter) {
                sitePromise = lastValueFrom(this._siteService.getSiteName(this.siteIdFilter)).then(result => {
                    this.siteName = result;
                });
            }

            let parcelPromise: Promise<void>;

            if (!this.isEmbededMode && this.parcelIdFilter) {
                parcelPromise = this._parcelService.getView(this.parcelIdFilter, false).then(result => {
                    this.parcelName = result.parcel.acctNum;
                    this.siteId = result.siteId;
                });
            }

            let companyInfo: Core.CompanyModel;

            const companyPromise = this._companyService.load(this.companyId, true, false);
            companyPromise.then((company) => {
                this.companyName = company.companyName;
                companyInfo = company;
            });

            await Promise.all([
                companyPromise,
                sitePromise,
                parcelPromise
            ]);

            this.breadcrumbs.push({
                name: this.companyName,
                target: 'company',
                options: { companyId: this.companyId }
            });

            if (this.siteName) {
                this.breadcrumbs.push({
                    name: this.siteName,
                    target: 'site',
                    options: { companyId: this.companyId, siteId: this.siteIdFilter }
                });
            }

            if (this.parcelName) {
                this.breadcrumbs.push({
                    name: this.parcelName,
                    target: 'parcel',
                    options: { companyId: this.companyId, siteId: this.siteId, parcelId: this.parcelIdFilter }
                });
            }

            this.endDates = await lastValueFrom(this._rentRollRepository.getRentRollEndDates(this.companyId, this.siteIdFilter));
            this.selectedEndDate = _.maxBy(this.endDates, x => new Date(x));

            this.isInitialized = true;
        } finally {
            if (this.isEmbededMode) {
                this.onLoading = false;
                this.onLoadingChange.emit(false);
            } else {
                busyRef.hide();
            }
        }
    }
}
